import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSideBar } from '../../features/sideBarSlice';
import { homeRoutes } from '../../routes';
import { Link } from 'react-router-dom';
import { Collapse, Menu, MenuItem } from '@mui/material';
import Person2Icon from '@mui/icons-material/Person2';
import { logout } from '../../features/authSlice';
import NightlightIcon from '@mui/icons-material/Nightlight';
import { changeMode } from '../../features/mode.slice';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import './index.css'
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';

const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);





export default function SideBar() {
  const theme = useTheme();

  const dispatch = useDispatch();
  const open = useSelector((state) => state.sideBar.sideBarOpen);

    const handleDrawerOpen = () => {
    dispatch(setShowSideBar())
    };

    const handleDrawerClose = () => {
        dispatch(setShowSideBar())
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleLogout = () => {
      dispatch(logout());
    }

    

  const [openNest, setOpenNest] = React.useState({});

  const handleClickNest = (id) => {
    setOpenNest((prevState) => ({ ...prevState, [id]: !prevState[id] }));
    // setOpenNest(!openNest);
  };

  React.useEffect(() => {

  }, [openNest]);
    

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div
            style={{ marginLeft: 'auto' }}>
            {/* <IconButton onClick={changeThemeMode}>
              {mode === 'light' ?
                <NightlightIcon sx={{ color: 'white' }} />
                :
                <WbSunnyIcon sx={{ color: 'white' }} />
              }
            </IconButton> */}
            <IconButton
              color="inherit"
              aria-label="open menu"
              onClick={handleClick}
              edge="end"
              sx={{
                marginLeft: 'auto',
                // ...(open && { display: 'none' }),
              }}
            >
              <Person2Icon />
            </IconButton>
          </div>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleClose}>My account</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
         
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open} >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {homeRoutes.map((route, index) => (
            <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <Link to={route.path} className={'link-text'} >
              <ListItemButton
                
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={route.name} sx={{ opacity: open ? 1 : 0 }} />
                {open ? 
                  !openNest[route.id] ? 
                  <ExpandLess onClick={() => handleClickNest(route.id)}/>
                  : 
                  <ExpandMore onClick={() => handleClickNest(route.id)}/>
                  :
                  ''
                }
              </ListItemButton>
            </Link>
              {route.children && route.children.map((child, index) => (
            <Collapse key={index} in={!openNest[route.id]} timeout="auto" unmountOnExit>
                <List key={index} component="div" disablePadding>
                  <Link to={child.path} className={'link-text' }>
                  <ListItemButton sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    pl: open ? 4 : 2.5,
                    // color: 'black'
                  }}>
                    <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        textDecoration: 'none', 
                        // color: 'black'
                    }}>
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                    </ListItemIcon>
                    <ListItemText sx={{ opacity: open ? 1 : 0  }} primary={child.name} />
                  </ListItemButton>
                  </Link>
                </List>
              </Collapse>
              ))
              }
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Box>
  );
}